/**
 * Client for sending requests to the statistic api
 */
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'

class StatisticApiClient {
  makeRequest (url: string, data: any = null) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      const method = data !== null ? 'POST' : 'GET'

      xhr.open(method, url)
      xhr.onload = () => {
        let resolveValue = null
        if (xhr.responseText) {
          resolveValue = JSON.parse(xhr.responseText)
        }
        resolve(resolveValue)
        this.afterRequest()
      }
      xhr.onerror = () => {
        reject(JSON.parse(xhr.statusText))
        this.afterRequest()
      }
      xhr.onabort = () => {
        this.afterRequest()
      }
      this.beforeRequest()

      if (data !== null) { // POST
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')

        let body = []
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            body.push(key + '=' + encodeURIComponent(data[key]))
          }
        }
        xhr.send(body.join('&'))
      } else { // GET
        xhr.send()
      }
    })
  }

  getApiUrl (): string {
    return searcherryConfig.apiUrl + '/stat'
  }

  createSession () {
    let url = this.getApiUrl() + '/create-session'
    return this.makeRequest(url)
  }

  correctEvent (data: any) {
    let url = this.getApiUrl() + '/correct'
    return this.makeRequest(url, data)
  }

  synonymsDictUsageEvent (data: any) {
    let url = this.getApiUrl() + '/synonyms-dict-usage'
    return this.makeRequest(url, data)
  }

  browseCategoryEvent (data: any) {
    let url = this.getApiUrl() + '/browse-category'
    return this.makeRequest(url, data)
  }

  exitWithProductEvent (data: any) {
    let url = this.getApiUrl() + '/exit-product'
    return this.makeRequest(url, data)
  }

  exitWithCategoryEvent (data: any) {
    let url = this.getApiUrl() + '/exit-category'
    return this.makeRequest(url, data)
  }

  exitWithCloseEvent (data: any) {
    let url = this.getApiUrl() + '/exit-close'
    return this.makeRequest(url, data)
  }

  exitWithOldSearchEvent (data: any) {
    let url = this.getApiUrl() + '/exit-old-search'
    return this.makeRequest(url, data)
  }

  private beforeRequest () {
  }

  private afterRequest () {
  }
}

const statisticApiClient = new StatisticApiClient()

export default statisticApiClient
